import { render, staticRenderFns } from "./EditNotice.vue?vue&type=template&id=1d510b0e&scoped=true"
import script from "./EditNotice.vue?vue&type=script&lang=js"
export * from "./EditNotice.vue?vue&type=script&lang=js"
import style0 from "./EditNotice.vue?vue&type=style&index=0&id=1d510b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d510b0e",
  null
  
)

export default component.exports